export default __webpack_public_path__ + "/dist/images/1362003.0ffe74c300bcd2e227e1a01e98617ced.png";